import React from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="pt-12 pb-4 px-4 bg-white text-center" data-id="element-181">
      <div className="max-w-4xl mx-auto" data-id="element-182">
        <p className="md:text-xs text-gray-400 tracking-wider mb-4 font-[600] font-[Figtree,_sans-serif] text-[14px]" data-id="element-183">
          "Recurso educativo digital para docentes de Secundaria"
        </p>

        <h1 className="text-3xl md:text-5xl font-black mb-1 leading-tight tracking-tight" data-id="element-184">
          <span className="px-2 text-[#5B3FA0] bg-[#FFFFFF] font-[900] text-[32px]" data-id="element-185">
            EFEMÉRIDES LISTAS SECUNDARIA
          </span>
        </h1>

        <h2 className="md:text-2xl mb-3 text-gray-800 text-[16px] font-[700]" data-id="element-186">
          El recurso docente que te resuelve todas las efemérides del año en
          minuto
        </h2>

        <div className="block max-w-[600px] mx-auto mb-3" data-id="element-187">
          <img src="https://cdn.magicpatterns.com/uploads/xg5yLwdWuyaNe3aaeMankt/mockup_principal.png" alt="Efemérides Listas Secundaria" className="w-full h-auto object-contain drop-shadow-2xl rounded-xl" data-id="element-188" />
        </div>

        <div className="text-lg md:text-xl mb-4 text-gray-700 space-y-2 max-w-3xl mx-auto font-medium" data-id="element-189">
          <p className="text-[14px]" data-id="element-190">
            No pierdas tiempo buscando textos, actividades y propuestas para
            secundaria. Con este material vas a tener todo organizado, listo
            para usar y preparado para cada fecha del calendario escolar.
          </p>
        </div>

        <div className="bg-blue-50 rounded-2xl p-5 max-w-md mx-auto border border-blue-100" data-id="element-191">
          <p className="text-lg font-black text-gray-900 mb-3" data-id="element-192">
            👉 Acceso inmediato y organizado
          </p>
          <div className="space-y-2 text-left" data-id="element-193">
            <p className="text-base font-semibold text-gray-800 flex items-center" data-id="element-194">
              <span className="text-green-600 mr-2 text-lg" data-id="element-195">✔️</span> Comprás
              ahora
            </p>
            <p className="text-base font-semibold text-gray-800 flex items-center" data-id="element-196">
              <span className="text-green-600 mr-2 text-lg" data-id="element-197">✔️</span> Recibís un
              email automático
            </p>
            <p className="text-base font-semibold text-gray-800 flex items-center" data-id="element-198">
              <span className="text-green-600 mr-2 text-lg" data-id="element-199">✔️</span> Accedés a
              todo el contenido organizado por mes
            </p>
            <p className="text-base font-semibold text-gray-800 flex items-center" data-id="element-200">
              <span className="text-green-600 mr-2 text-lg" data-id="element-201">✔️</span> Podés
              descargar o utilizar directamente
            </p>
          </div>
        </div>
      </div>
    </section>;
}